import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VisaHeader.css';
import VisaInfo from './VisaInfo'
import info from '../assets/Vector-9.png';
import ForexImg from "../assets/Group 1618873619.svg";
import VisaImg from "../assets/visa main module.png";
import umbrellaImg from "../assets/Vector-44.png";
import searchPng from "../assets/SVG-5.png";
import info1 from "../assets/Vector (2).png";
import calendar from "../assets/bx_bx-calendar.png";
import GroupSvg from '../assets/visa.svg';
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';

const VisaHeader = () => {
  const [activeTab, setActiveTab] = useState('Visa');
  const [searchQuery, setSearchQuery] = useState('');
  const [originCountry, setOriginCountry] = useState('');
  const [destinationCountry, setDestinationCountry] = useState('');
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [showCalendar, setShowCalendar] = useState(false);

  const navigate = useNavigate();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleNavigation = (path, tab) => {
    setActiveTab(tab);
    navigate(path);
  };

  const handleSearch = async () => {
    const searchParams = {
      query: searchQuery,
      type: activeTab,
      origin: originCountry,
      destination: destinationCountry,
      dates: {
        from: dateRange[0].startDate,
        to: dateRange[0].endDate,
      },
    };
  
    try {
      console.log('Sending request:', searchParams);
  
      const response = await fetch('/api/search', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(searchParams),
      });
  
      const data = await response.json();
      console.log('Response received:', data);
  
      // Navigate to VisaInfo page after getting response
      navigate('/visa-info');
      
    } catch (err) {
      console.log('Backend not available:', err);
      // Optionally navigate even on failure
      navigate('/VisaInfo');
    }
  };
  

  return (
    <div className="travel-booking-container">
      <div className="background-wrapper">
        <img src={GroupSvg} className="background-svg" alt="background" />
        <div className="hero-content">
          <h3>Book your visa with ease</h3>
          <h4>quick processing, no stress, just approvals!</h4>
        </div>

        <div className="search-card">
          <div className="visa-tabs">
            <button
              className={`visa-tab-button ${activeTab === 'Holiday' ? 'active' : ''}`}
              onClick={() => handleNavigation('/tours', 'Holiday')}
            >
              <span className="icon">
                <img src={umbrellaImg} alt="tour" width={30} height={25} />
              </span>
              <span>Holiday</span>
            </button>

            <button
              className={`visa-tab-button ${activeTab === 'Visa' ? 'active' : ''}`}
              onClick={() => handleTabChange('Visa')}
            >
              <span className="icon">
                <img src={VisaImg} alt="visa" width={30} height={30} />
              </span>
              <span>Visa</span>
            </button>

            <button
              className={`visa-tab-button ${activeTab === 'Forex' ? 'active' : ''}`}
              onClick={() => handleTabChange('Forex')}
            >
              <span className="icon">
                <img src={ForexImg} alt="forex" width={30} height={30} />
              </span>
              <span>Forex</span>
            </button>
          </div>

          <div className="help-text">
            <span className="help-icon">
              <img src={info} alt="help" />
            </span>
            <span>Need some help?</span>
          </div>

          <div className="search-bar-visa">
            
              <div className="search-input-container">
                <div className="search-icon" style={{display:'flex'}}>Origin Country  
                  <span className='info-icon-container'>
                    <img src={info1}></img>
                    <span className='bubble'>Please select origin as the country you are resident of/applying in</span>
                  </span>
                </div>

                <input
                  type="text"
                  value={originCountry}
                  onChange={(e) => setOriginCountry(e.target.value)}
                />
              </div>

              <div className="search-input-container" style={{display:'flex',marginTop:'auto'}}>
                <div className="search-icon">Destination Country</div>
                <input
                  type="text"
                  value={destinationCountry}
                  onChange={(e) => setDestinationCountry(e.target.value)}
                />
              </div>
            
              <div className="search-input-container" style={{display:'flex',marginTop:'auto'}}>
                <div className="search-icon">Travel Date</div>
                <div
                  className="date-range-input"
                  onClick={() => setShowCalendar((prev) => !prev)}
                >
                  {`${format(dateRange[0].startDate, 'dd/MM/yyyy')} - ${format(dateRange[0].endDate, 'dd/MM/yyyy')}`} <img src={calendar}></img>
                </div>
                {showCalendar && (
                  <div className="calendar-popup">
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => setDateRange([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={dateRange}
                    />
                  </div>
                )}
              </div>
                <button className="search-button" onClick={handleSearch}>
                  Search
                </button>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaHeader;
